import { ImportType } from './import-type.enum';

export class ImportResponse {
   name: string;
   status: string;
   message: string;
   type: ImportType;
   conflictObject: any;
   originalObject: any;
   subElements: Array<ImportResponse>;
}